// Indonesian number & date formatting (id-ID)

export const rp = (v) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(v || 0));

export const num = (v) => Number(v || 0).toLocaleString("id-ID");

export const pcs = (v) => `${num(v)} PCS`;

export const pct = (v) =>
  `${Number(v || 0).toLocaleString("id-ID", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;

export const signed = (v, unit = "") => {
  const n = Number(v || 0);
  const s = n > 0 ? "+" : "";
  return `${s}${num(n)}${unit ? " " + unit : ""}`;
};

const ID_MONTHS = ["", "Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli",
  "Agustus", "September", "Oktober", "November", "Desember"];

export const fmtDate = (s) => {
  if (!s) return "-";
  const [y, m, d] = s.split("-");
  if (!d) return s;
  return `${parseInt(d)} ${ID_MONTHS[parseInt(m)]} ${y}`;
};

export const monthLabel = (mkey) => {
  if (!mkey) return "";
  const [y, m] = mkey.split("-");
  return `${ID_MONTHS[parseInt(m)]} ${y}`;
};

export const monthOptions = (count = 12) => {
  const out = [];
  const now = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const mkey = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    out.push({ value: mkey, label: monthLabel(mkey) });
  }
  return out;
};

export const TYPE_LABELS = {
  AMBIL: "Ambil", SETOR: "Setor", BON: "Bon", BAYAR: "Bayar", KASBON: "Kasbon", PINJAMAN: "Pinjaman",
  KOREKSI: "Koreksi", SALDO_AWAL: "Saldo Awal", RIJEK: "Rijek Sortir",
};

export const STATUS_LABELS = {
  PENDING: "Menunggu", CONFIRMED: "Terkonfirmasi", CANCELLED: "Dibatalkan", CORRECTED: "Dikoreksi",
};
